import { ClockCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Space, Tag, Typography } from "antd";
import { COLORS } from "~/utils/constants";
import type { RentDueVariant } from "./constants";

export type RentDueCollapseLabelProps = {
  variant: RentDueVariant;
  title: string;
  count: number;
  totalBalanceDue: number;
  periodLabel: string;
  totalDueLabel: string;
};

export const RentDueCollapseLabel = ({
  variant,
  title,
  count,
  totalBalanceDue,
  periodLabel,
  totalDueLabel,
}: RentDueCollapseLabelProps) => {
  const isNeverPaid = variant === "neverPaid";
  const accentColor = isNeverPaid ? COLORS.crimson_red : COLORS.baby_blue;
  const Icon = isNeverPaid ? ExclamationCircleOutlined : ClockCircleOutlined;

  return (
    <div className="custom-table-header" style={{ width: "100%" }}>
      <Space align="start" size="middle" style={{ width: "100%" }}>
        <Icon style={{ color: accentColor, fontSize: 20, marginTop: 2 }} />
        <Space
          direction="vertical"
          size={2}
          className="custom-table-header-title"
          style={{ flex: 1, minWidth: 0 }}
        >
          <Space wrap size="small">
            <Typography.Text strong style={{ color: accentColor, fontSize: 15 }}>
              {title}
            </Typography.Text>
            <Tag color={isNeverPaid ? "error" : "processing"}>{count}</Tag>
            {count > 0 && totalBalanceDue > 0 && (
              <Typography.Text strong style={{ color: accentColor }}>
                {totalDueLabel}
              </Typography.Text>
            )}
          </Space>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            {periodLabel}
          </Typography.Text>
        </Space>
      </Space>
    </div>
  );
};
